/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 24.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import t from "../../trans";
import {Modal} from "../../components/Bootstrap";
import PasswordForm from "../../components/PasswordForm";

class AskPasswordModal extends React.Component {
    static propTypes = {
        /**
         * Form fields validation messages
         */
        validation: PropTypes.object,
        /**
         * If form input fields and button should be disabled
         */
        disabled: PropTypes.bool,
        /**
         * Default value for e-mail address field
         */
        email: PropTypes.string,
        password: PropTypes.string,
        code: PropTypes.string,
        /**
         * Should password form contain also two-factor code field
         */
        askCode: PropTypes.bool,
        /**
         * Callback called when role or checkbox value was changed. Field name is "role" or "isDefault"
         * onChange(fieldName, value)
         */
        onChange: PropTypes.func.isRequired,
        /**
         * Callback called when user closes the modal window. Parameter okClicked is boolean indicating if the
         * form is closed because of clicking to the "Authenticate" button or not.
         * onClose(okClicked)
         */
        onClose: PropTypes.func.isRequired
    };

    static defaultProps = {
        isRequired: false
    };

    constructor(props) {
        super(props);
        this.state = {};
        this.onClose = this.onClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    onClose() {
        this.props.onClose(false);
    }
    onSubmit() {
        this.props.onClose(true);
    }

    render() {
        return (
            <Modal modalClass="inmodal fade" modalAttrib={{"data-backdrop": "static", "data-keyboard": "false"}} id="selectRole" tabIndex="-1" role="dialog" aria-hidden="true" onClose={this.onClose}>
                <Modal.Content>
                    <Modal.Header>
                        <button type="button" className="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span className="sr-only">{t("Close")}</span></button>
                        <h4 className="modal-title">{t("Authentication required")}</h4>
                    </Modal.Header>
                    <Modal.Body>
                        <PasswordForm
                            validation={this.props.validation}
                            disabled={this.props.disabled}
                            email={this.props.email}
                            password={this.props.password}
                            code={this.props.code}
                            askCode={this.props.askCode}
                            noNewPassword={true}
                            lockEmail={true}
                            onChange={this.props.onChange}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-white" data-dismiss="modal">{t("Cancel")}</button>
                        <button type="button" className="btn btn-primary" onClick={this.onSubmit}>{t("Authenticate")}</button>
                    </Modal.Footer>
                </Modal.Content>
            </Modal>
        );
    }

}

export default AskPasswordModal;
